package org.catharsis.spendtel.di

import org.catharsis.spendtel.feature.presentation.ExpenseReportViewModel
import org.catharsis.spendtel.feature.presentation.PublicShareViewModel
import org.catharsis.spendtel.feature.presentation.HomeViewModel
import org.catharsis.spendtel.feature.presentation.SpendTelServiceViewModel
import org.catharsis.spendtel.feature.presentation.SpendTelViewModel
import org.catharsis.spendtel.feature.presentation.auth.AuthenticationViewModel
import org.catharsis.spendtel.feature.presentation.financialgoal.FinancialGoalViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

val appModule = module {
    viewModelOf(::SpendTelServiceViewModel)
    viewModelOf(::AuthenticationViewModel)
    viewModel { params ->
        FinancialGoalViewModel(
            authenticationRepo = get(),
            spendTelRepo = get(),
            analytics = get(),
            isEditMode = params.getOrNull() ?: false,
        )
    }
    viewModelOf(::HomeViewModel)
    viewModel { (reportId: String) ->
        ExpenseReportViewModel(
            reportId = reportId,
            authenticationRepo = get(),
            expenseReportRepo = get(),
            analytics = get(),
        )
    }
    viewModel { (shareId: String) ->
        PublicShareViewModel(
            shareId = shareId,
            expenseReportRepo = get(),
        )
    }
    viewModelOf(::SpendTelViewModel)

    includes(platformDataModule())
}
